<script>
import imgEmptyPlugin from '@/components/countly/images/icons/empty-plugin.svg';
import countlyVue from '../../compat/vue-core';
import i18n from '../../../../i18n';

export default countlyVue.components.BaseComponent.extend({
  template: '',
  props: {
    title: { default: i18n.tc('common.emtpy-view-title'), type: String },
    subTitle: { default: i18n.tc('common.emtpy-view-subtitle'), type: String },
    actionTitle: { default: 'Create', type: String },
    actionFunc: { default: null, type: Function },
    hasAction: { default: false, type: Boolean },
    hasCreateRight: { default: true, type: Boolean },
  },
  data() {
    return {
      imgEmptyPlugin,
    };
  },
});
</script>
<template>
  <div class="bu-mt-5 bu-pt-4 bu-is-flex bu-is-flex-direction-column bu-is-align-items-center cly-vue-empty-view">
    <slot name="icon">
      <div class="bu-mt-6">
        <img
          class="cly-vue-empty-view__img"
          :src="imgEmptyPlugin"
        >
      </div>
    </slot>
    <div class="bu-mt-2 bu-is-flex bu-is-flex-direction-column bu-is-align-items-center">
      <slot name="title">
        <h3 class="color-cool-gray-100 bu-mt-4">
          {{ title }}
        </h3>
      </slot>
      <slot name="subTitle">
        <div class="bu-mt-4 bu-mb-5 text-medium color-cool-gray-50 bu-has-text-centered cly-vue-empty-view__subtitle">
          <span>
            {{ subTitle }}
          </span>
        </div>
      </slot>
      <slot
        v-if="hasCreateRight && hasAction"
        name="action"
      >
        <div
          class="bu-is-clickable button bu-has-text-centered color-blue-100 pointer"
          @click="actionFunc"
        >
          {{ actionTitle }}
        </div>
      </slot>
    </div>
  </div>
</template>
